import { useState } from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate, useParams } from 'react-router-dom';
import logoWithoutText from '../../assets/logo_without_text.png';
import burgerIcon from '../../assets/navbar/burgerMenu.svg';
import crossIcon from '../../assets/navbar/crossIcon.svg';
import { useTranslation } from '../../services/LanguageContext';
import './navigationBar.scss';

const NavigationBar = () => {
  const { lang } = useParams(); // Get 'lang' from the URL
  const navigate = useNavigate(); // For navigation
  const { language, changeLanguage, t } = useTranslation(); // Use new translation hook
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);

  // Update language context and navigate to new language route
  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value.toUpperCase();
    
    // Navigate to the new language route
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/');
    pathSegments[1] = newLanguage.toLowerCase(); // Replace the language segment
    const newPath = pathSegments.join('/');
    
    navigate(newPath);
    
    // The useUrlLanguageSync hook in Layout will handle the language change
  };

  return (
    <>
      <Navbar expanded={expanded} className="custom-navbar shadow" expand="lg" fixed="top">
        <div className="container">
          <Navbar.Brand className={`${expanded ? 'isOpen' : ''}`}>
            <a href={`/${lang}`}>
              <img src={logoWithoutText} alt="logo" height={40} className="logo-desktop" />
              <img src={logoWithoutText} alt="logo" height={50} className="logo-mobile" />
            </a>
          </Navbar.Brand>
          <Nav className="Kostenlos-starten-container">
            <Nav.Link className={`Kostenlos-starten ${expanded ? 'isOpen' : ''}`} href={`/${lang}/Anmeldung`}>
              {t('nav_get_started', 'Kostenlos starten')}
            </Nav.Link>
          </Nav>
          <Navbar.Toggle
            style={{ paddingRight: '0' }}
            aria-controls="basic-navbar-nav"
            onClick={handleToggle}
            className="custom-toggler"
          >
            <img src={expanded ? crossIcon : burgerIcon} alt="menu icon" />
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center nav-menu-container">
            <div className="nav-menu-divider"></div>
            <Nav className="mx-auto navbar-items">
              <Nav.Link href={`/${lang}/`}>{t('nav_home', 'Startseite')}</Nav.Link>
              <Nav.Link href={`/${lang}/about`}>{t('nav_about', 'Über uns')}</Nav.Link>
              <Nav.Link href={`/${lang}/faq`}>{t('nav_faq', 'FAQ')}</Nav.Link>
            </Nav>

            <div className="language-select-container">
              <select onChange={handleLanguageChange} value={language.toLowerCase()} className="form-control">
                <option value="de">De</option>
                <option value="en">En</option>
              </select>
            </div>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};

export default NavigationBar;
